/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi
 */
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
})(function($) {
    $.fn.marquee = function(options) {
        return this.each(function() {
            var o = $.extend({}, $.fn.marquee.defaults, options),
                $this = $(this),
                $marqueeWrapper, containerWidth, animationCss, verticalDir, elWidth,
                loopCount = 3,
                playState = 'animation-play-state',
                css3AnimationIsSupported = false,
                _prefixedEvent = function(element, type, callback) {
                    var pfx = ["webkit", "moz", "MS", "o", ""];
                    for (var p = 0; p < pfx.length; p++) {
                        if (!pfx[p]) type = type.toLowerCase();
                        element.addEventListener(pfx[p] + type, callback, false);
                    }
                },
                _objToString = function(obj) {
                    var tabjson = [];
                    for (var p in obj) {
                        if (obj.hasOwnProperty(p)) {
                            tabjson.push(p + ':' + obj[p]);
                        }
                    }
                    return '{' + tabjson.join(',') + '}';
                },
                _startAnimationWithDelay = function() {
                    $this.timer = setTimeout(animate, o.delayBeforeStart);
                },
                methods = {
                    pause: function() {
                        if (css3AnimationIsSupported && o.allowCss3Support) {
                            $marqueeWrapper.css(playState, 'paused');
                        } else if ($.fn.pause) {
                            $marqueeWrapper.pause();
                        }
                        $this.data('runningStatus', 'paused');
                        $this.trigger('paused');
                    },
                    resume: function() {
                        if (css3AnimationIsSupported && o.allowCss3Support) {
                            $marqueeWrapper.css(playState, 'running');
                        } else if ($.fn.resume) {
                            $marqueeWrapper.resume();
                        }
                        $this.data('runningStatus', 'resumed');
                        $this.trigger('resumed');
                    },
                    toggle: function() {
                        methods[$this.data('runningStatus') === 'resumed' ? 'pause' : 'resume']();
                    },
                    destroy: function() {
                        clearTimeout($this.timer);
                        $this.find("*").addBack().off();
                        $this.html($this.find('.js-marquee:first').html());
                    }
                };

            if (typeof options === 'string') {
                if ($.isFunction(methods[options])) {
                    if (!$marqueeWrapper) {
                        $marqueeWrapper = $this.find('.js-marquee-wrapper');
                    }
                    if ($this.data('css3AnimationIsSupported') === true) {
                        css3AnimationIsSupported = true;
                    }
                    methods[options]();
                }
                return;
            }

            var dataAttributes = {}, attr;
            $.each(o, function(key) {
                attr = $this.attr('data-' + key);
                if (typeof attr !== 'undefined') {
                    if (attr === 'true') attr = true;
                    else if (attr === 'false') attr = false;
                    o[key] = attr;
                }
            });

            if (o.speed) {
                o.duration = parseInt($this.width(), 10) / o.speed * 1000;
            }

            verticalDir = o.direction === 'up' || o.direction === 'down';

            $this.wrapInner('<div class="js-marquee"></div>');
            var $el = $this.find('.js-marquee').css({ 'margin-right': o.gap, 'float': 'left' });

            $this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');
            $marqueeWrapper = $this.find('.js-marquee-wrapper');

            // Additional setup and animation logic continues here...

        });
    };

    $.fn.marquee.defaults = {
        allowCss3Support: true,
        css3easing: 'linear',
        easing: 'linear',
        delayBeforeStart: 1000,
        direction: 'left',
        duration: 5000,
        gap: 20,
        pauseOnCycle: false,
        pauseOnHover: false,
        startVisible: false
    };
});